<template>
  <div :style="oracle.isMobile() ? 'width: 100%;' : 'width: 80%'">
    <v-dialog scrollable width="500" v-model="showAttachments">
      <v-card>
        <v-card-title>{{ language.lang('Attachments') }}</v-card-title>
        <v-card-text v-if="contract != null && showAttachments">
          <div class="d-flex flex-column mt-3 mb-5 border-bottom">
            <div style="align-items: center" class="d-flex flex-row border-bottom p-3" :key="index"
                 v-for="(item, index) in attachments">
              <i style=" font-size: 18px;color: #427BD5" class="fa fa-file-pdf-o"></i>
              <span :class="isEN ? 'mr-auto ml-2 ' : 'ml-auto mr-2 '"><b>{{ item.title }}</b>
                                <span
                                    style="font-size: 10px">{{ ' ' + language.lang(item.type == 'consultant' ? '(Uploaded by consultant)' : '(Uploaded by client)') }}</span></span>
              <i @click="download(item)" style="font-size: 18px;color: #3aaf85"
                 class="fa fa-download"></i>
              <i @click="attachments.splice(index, 1)"
                 v-if="(isLawyer && item.type == 'consultant') || (!isLawyer && item.type == 'client')"
                 :class="isEN ? 'ml-2' : 'mr-2'" style="font-size: 18px;color: #cd201f"
                 class="fa fa-times"></i>
            </div>
            <span class="mt-3 mb-2 font-weight-bold">{{ language.lang('Upload an attachment') }}</span>
            <div style="align-items: center" class="d-flex flex-row">
              <v-text-field
                  v-model="title"
                  :label="language.lang('Attachment title')"
              ></v-text-field>
              <v-file-input v-model="attachment"
                            :label="language.lang('Attachment')" persistent-hint
                            :hint="'pdf, docx, xls, png, jpg, txt'">
              </v-file-input>
              <v-progress-circular :style="uploading ? 'opacity: 1' : 'opacity: 0'" class="mr-3"
                                   indeterminate></v-progress-circular>
            </div>
            <base-button style="width: fit-content" tag="span" @click="addAttachment"
                         type="default" class="mb-3 mt-3 mr-2 ml-2">
              {{ language.lang('Add attachment') }}
            </base-button>
          </div>
          <base-button tag="span" @click="showAttachments = false"
                       type="secondary" class="mb-2 mt-2">
            {{ language.lang('Discard') }}
          </base-button>
          <base-button tag="span" @click="saveAttachments"
                       type="primary" class="mb-2 mt-2 mr-2 ml-2">
            {{ language.lang('Save attachments') }}
          </base-button>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog scrollable width="500" v-model="showForm">
      <v-card>
        <v-card-text v-if="form != null">
          <div class="d-flex flex-column mt-3 mb-3">
            <div class="border-bottom" :key="index" v-for="(item, index) in form.record_form[0]">
              <span class="mt-2" style="color: #999999; font-size: 12px">{{ item.title }}</span>
              <div v-if="item.flag != null">
                <span class="font-weight-bold">{{ item.options[item.flag].title }}</span>
              </div>
            </div>
          </div>
          <base-button tag="span" @click="showForm = false"
                       type="secondary" class="mb-2 mt-2">
            {{ language.lang('Discard') }}
          </base-button>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog scrollable width="500" v-model="showContract">
      <v-card>
        <v-card-text v-if="contract != null && showContract">
          <div class="d-flex flex-column mt-3 mb-5">
            <v-text-field
                disabled
                v-model="contract.user.username"
                :label="language.lang('Client')"
            ></v-text-field>
            <v-select :items="plans"
                      disabled
                      item-text="plan_title"
                      item-value="plan_id"
                      v-model="contract.plan"
                      :label="language.lang('Plan Name')">

            </v-select>
            <v-text-field
                persistent-hint
                type="number"
                :hint="language.lang('In Dollars')"
                v-model="contract.total"
                :label="language.lang('Total contract price')"
            ></v-text-field>
            <v-text-field
                persistent-hint
                type="number"
                :hint="language.lang('In Dollars')"
                v-model="contract.total_payed"
                :label="language.lang('Paid amount')"
            ></v-text-field>
            <v-text-field
                persistent-hint
                type="number"
                :hint="language.lang('In Dollars')"
                v-model="contract.commission"
                :label="language.lang('Consultant share')"
            ></v-text-field>
            <v-text-field
                persistent-hint
                type="number"
                :hint="language.lang('In Dollars')"
                v-model="contract.commission_payed"
                :label="language.lang('Consultant received share')"
            ></v-text-field>
            <v-text-field
                persistent-hint
                type="number"
                :hint="language.lang('In Dollars')"
                v-model="contract.current_installment"
                :label="language.lang('Current installment')"
            ></v-text-field>
          </div>
          <base-button tag="span" @click="showContract = false"
                       type="secondary" class="mb-2 mt-2">
            {{ language.lang('Discard') }}
          </base-button>
          <base-button tag="span" @click="saveContact"
                       type="primary" class="mb-2 mt-2 mr-2 ml-2">
            {{ language.lang('Save contract') }}
          </base-button>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog scrollable width="500" v-model="showPlan">
      <v-card>
        <v-card-text v-if="plan != null">
          <div class="d-flex flex-column mt-3 mb-3">
            <div v-if="!oracle.isEmpty(plan.plan_title)" class="border-bottom">
                            <span class="mt-2"
                                  style="color: #999999; font-size: 12px">{{ language.lang('Plan Name') }}</span>
              <div>
                <span class="font-weight-bold">{{ search(plan.plan_title) }}</span>
              </div>
            </div>
            <div v-if="!oracle.isEmpty(plan.plan_refund)" class="border-bottom">
                            <span class="mt-2"
                                  style="color: #999999; font-size: 12px">{{ language.lang('Plan Refund') }}</span>
              <div>
                <span
                    class="font-weight-bold">{{ plan.plan_refund + " " + language.lang('percent from contract') }}</span>
              </div>
            </div>
            <div v-if="!oracle.isEmpty(plan.plan_price)" class="border-bottom">
                            <span class="mt-2"
                                  style="color: #999999; font-size: 12px">{{ language.lang('Plan Price') }}</span>
              <div>
                <span class="font-weight-bold">{{ plan.plan_price + "$" }}</span>
              </div>
            </div>
            <div v-if="!oracle.isEmpty(plan.plan_installments)" class="border-bottom">
              <span class="mt-2" style="color: #999999; font-size: 12px">{{ language.lang('Plan Installments') }}</span>
              <div>
                <span class="font-weight-bold">{{ plan.plan_installments + " " + language.lang('part(s)') }}</span>
              </div>
            </div>
            <div v-if="!oracle.isEmpty(plan.plan_time)" class="border-bottom">
              <span class="mt-2" style="color: #999999; font-size: 12px">{{ language.lang('Plan Duration') }}</span>
              <div>
                <span class="font-weight-bold">{{ plan.plan_time + " " + language.lang('day(s)') }}</span>
              </div>
            </div>
            <div v-if="!oracle.isEmpty(plan.plan_brief)" class="border-bottom">
                            <span class="mt-2"
                                  style="color: #999999; font-size: 12px">{{ language.lang('Plan Details') }}</span>
              <div>
                <span class="font-weight-bold">{{ plan.plan_brief }}</span>
              </div>
            </div>
          </div>
          <base-button tag="span" @click="showPlan = false"
                       type="secondary" class="mb-2 mt-2">
            {{ language.lang('Discard') }}
          </base-button>
        </v-card-text>
      </v-card>
    </v-dialog>
    <div class="d-flex flex-row align-content-center mb-3" v-for="(item, index) in subscriptions" :key="index">
      <img v-if="!isLawyer" :class="'shadow-lg--hover review-avatar ' + (isEN? 'mr-2' : 'ml-2')"
           :src="item.lawyer != null && item.lawyer.lawyer_cover != null ? item.lawyer.lawyer_cover :
                                 require('@/assets/image/user_avatar.png')"
           alt="">
      <img v-else :class="'shadow-lg--hover review-avatar ' + (isEN? 'mr-2' : 'ml-2')"
           :src="item.user != null && item.user.user_avatar != null ? item.user.user_avatar :
                                 require('@/assets/image/user_avatar.png')"
           alt="">
      <div class="d-flex flex-column flex">
        <v-card style="padding: 10px 20px">
          <div @click="item.expand = !item.expand"
               :style="oracle.isMobile() ? '' : 'align-items: center; align-content: center;'"
               style="width: 100%; " class="d-flex " :class="!oracle.isMobile() ? 'flex-row' : 'flex-column'">
            <div class="d-flex flex-column">
              <h6 class="font-weight-bold">{{
                  isLawyer ? item.user.username :
                      item.lawyer.lawyer_title
                }}</h6>
              <h6 v-if="isLawyer" class="font-weight-bold"
                  style="font-size: 11px; margin-bottom: 0 !important; direction: ltr !important;">
                {{
                  item.user.phone !=
                  null ? ('+98' + item.user.phone.substring(1)) : item.user.email
                }}</h6>
            </div>
            <h6 style="margin-bottom: 0 !important;" class="font-weight-bold"
                :class="isEN && !oracle.isMobile() ? 'ml-auto' : 'mr-auto'">
                            <span style="font-weight: normal !important; font-size: 12px; ">
                                {{ oracle.format(item.count) + language.lang(" Document(s)") }}</span>
            </h6>
            <i class="fa"
               :class="(item.expand ? ' fa-chevron-up ' : ' fa-chevron-down ')
                            + (oracle.isMobile() ? 'mt-2' : (isEN ? 'ml-3 mr-1' : 'mr-3 ml-1'))"></i>
          </div>
          <div class="d-flex flex-column" v-if="item.expand">
            <div class="d-flex flex-column" :key="index" v-for="(child, index) in item.array">
              <v-container v-if="isLawyer">
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-select :items="steps"
                              v-model="child.state"
                              item-text="abbr"
                              item-value="state"
                              :hint="language.lang('Set client state')"
                              persistent-hint>
                    </v-select>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-textarea
                        v-model="child.data[child.state]"
                        :label="language.lang('Brief details about the current progress')"
                    >
                    </v-textarea>
                  </v-col>
                </v-row>
              </v-container>
              <div @click="openPlan(child)" class="ml-2 mr-2"
                   style="font-size: 12px; font-weight: normal; color: #999999">
                {{ language.lang('Plan:') }}<span style="color: #2b2b58 !important;"
                                                  class="font-weight-bold ml-2 mr-2 text-underline">
                        {{ child.copy != null ? child.copy.plan_title : child.plan.plan_title }}</span>
              </div>
              <div class="ml-2 mr-2" style="font-size: 12px; font-weight: normal; color: #999999">
                {{ language.lang('Apply status:') }}<span style="color: #2b2b58 !important;"
                                                          class="font-weight-bold ml-2 mr-2">
                        {{ translate(child.state) }}</span>
              </div>
              <div class="ml-2 mr-2" style="font-size: 12px; font-weight: normal; color: #999999">
                {{ language.lang('Current status details:') }}<span style="color: #2b2b58 !important;"
                                                                    class="font-weight-bold ml-2 mr-2">
                        {{ child.data[child.state] != null ? child.data[child.state] : '-' }}</span>
              </div>
              <div class="ml-2 mr-2" style="font-size: 12px; font-weight: normal; color: #999999">
                {{ language.lang('Total contract price:') }}<span v-if="child.total != null"
                                                                  style="color: #2b2b58 !important; direction: rtl !important;"
                                                                  class="font-weight-bold ml-2 mr-2">
                        {{ oracle.format(child.total) + "$" }}</span>
              </div>
              <div class="ml-2 mr-2" style="font-size: 12px; font-weight: normal; color: #999999">
                {{ language.lang('Paid amount:') }}<span v-if="child.total_payed != null"
                                                         style="color: #2b2b58 !important; direction: rtl !important;"
                                                         class="font-weight-bold ml-2 mr-2">
                        {{ oracle.format(child.total_payed) + "$" }}</span>
              </div>
              <div v-if="isLawyer" class="ml-2 mr-2"
                   style="font-size: 12px; font-weight: normal; color: #999999">
                {{ language.lang('Consultant share:') }}<span v-if="child.commission != null"
                                                              style="color: #2b2b58 !important; direction: rtl !important;"
                                                              class="font-weight-bold ml-2 mr-2">
                        {{ oracle.format(child.commission) + "$" }}</span>
              </div>
              <div v-if="isLawyer" class="ml-2 mr-2"
                   style="font-size: 12px; font-weight: normal; color: #999999">
                {{ language.lang('Consultant received share:') }}<span
                  v-if="child.commission_payed != null"
                  style="color: #2b2b58 !important; direction: rtl !important;"
                  class="font-weight-bold ml-2 mr-2">
                        {{ oracle.format(child.commission_payed) + "$" }}</span>
              </div>
              <div v-if="isLawyer" class="ml-2 mr-2"
                   style="font-size: 12px; font-weight: normal; color: #999999">
                {{ language.lang('Current installment:') }}<span
                  style="color: #2b2b58 !important; direction: rtl !important;"
                  class="font-weight-bold ml-2 mr-2">
                        {{ oracle.format(child.current_installment) }}</span>
              </div>
              <!--                            <div class="ml-2 mr-2" style="font-size: 12px; font-weight: normal; color: #999999">-->
              <!--                                {{language.lang('Create at:')}}<span-->
              <!--                                    style="color: #2b2b58 !important; direction: rtl !important;"-->
              <!--                                    class="font-weight-bold ml-2 mr-2">-->
              <!--                        {{oracle.date(child.create_at)}}</span>-->
              <!--                            </div>-->
              <div :style="oracle.isMobile() ? 'margin-top: 10px;' : ''"
                   :class="isEN && !oracle.isMobile() ? 'ml-auto' : 'mr-auto'">
                <base-button v-if="isLawyer" tag="span" @click="editItem(child)"
                             type="info" class="mb-2 mt-2"
                             :style="oracle.isMobile() ? 'width : 100%' : ''"
                             :class="'mr-0 ml-0'">
                  {{ language.lang('Edit payment Details') }}
                </base-button>
                <base-button v-if="isLawyer" tag="span" @click="saveItem(child, item)"
                             type="default" :class="oracle.isMobile() ? 'mr-0 ml-0' : 'mr-2 ml-2'"
                             :style="oracle.isMobile() ? 'width : 100%' : ''"
                             class="mb-2 mt-2">
                  {{ language.lang('Save changes') }}
                </base-button>
                <base-button class="mb-2 mt-2" :class="oracle.isMobile() ? 'mr-0 ml-0' : ''" tag="span"
                             @click="openAttachments(child)"
                             :style="oracle.isMobile() ? 'width : 100%' : ''"
                             type="warning">
                  {{ language.lang('Manage Attachments') }}
                </base-button>
              </div>
              <div style="width: 100%; height: 1px; background-color: #999999;" class="mt-3 mb-3"></div>
            </div>
            <div style="width: 100%">
              <base-button
                  v-if="isLawyer && item.hasForm" tag="span" @click="openForm(item)"
                  type="danger" class="mb-2 mt-2">
                {{ language.lang('View Evaluation Form') }}
              </base-button>
              <base-button class="mb-2 mt-2" v-else-if="!isLawyer" tag="span" @click="openLawyer(item)"
                           type="success" :style="isEN ? 'float: right' : 'float: left'">
                {{ language.lang('Get in touch') }}
              </base-button>
            </div>
          </div>
        </v-card>
      </div>
    </div>
    <Placeholder v-if="subscriptions != null && subscriptions.length == 0"></Placeholder>
    <v-progress-circular v-if="subscriptions == null" color="#00aff0" indeterminate
                         class="m-5 text-center"></v-progress-circular>
  </div>
</template>
<script>
import oracle from "@/utils/oracle";
import language from "@/utils/language";
import Placeholder from "@/views/global/Placeholder";

export default {
  components: {Placeholder},
  props: {
    lawyer: Object,
  },
  data: () => ({
    plans: [],
    uploading: false,
    form: null,
    plan: null,
    showForm: false,
    showPlan: false,
    showAttachments: false,
    showContract: false,
    contract: null,
    oracle: oracle,
    language: language,
    isEN: oracle.isEN(),
    subscriptions: null,
    title: null,
    attachments: [],
    attachment: null,
    steps: [
      {state: 0, abbr: language.lang('Consultation')},
      // {state: 1, abbr: language.lang('Select a immigration consultant')},
      {state: 2, abbr: language.lang('Send initial documents by the user')},
      {state: 3, abbr: language.lang('Pay the first installment')},
      {state: 4, abbr: language.lang('signing agreement')},
      {
        state: 5,
        abbr: language.lang('Sending the required documents for the desired immigration program by the user')
      },
      {state: 6, abbr: language.lang('Receipt and approval of documents by a consultant')},
      {state: 7, abbr: language.lang('Ongoing case')},
      {state: 8, abbr: language.lang('Receive approvals and acceptance')},
      {state: 9, abbr: language.lang('Pay the second installment')},
      {state: 10, abbr: language.lang('Sending the required documents for the visa by the client')},
      {state: 11, abbr: language.lang('Receipt and approval of documents by a consultant')},
      {state: 12, abbr: language.lang('Send documents to the Immigration Office to obtain a visa')},
      {state: 13, abbr: language.lang('Receive a fingerprint letter')},
      {state: 14, abbr: language.lang('Determine the time of fingerprinting')},
      {state: 15, abbr: language.lang('Get the result of fingerprinting')},
      {state: 16, abbr: language.lang('Get a visa result')},
      {state: 17, abbr: language.lang('Send a passport to get a visa')},
      {state: 18, abbr: language.lang('Ticket purchase')},
      {state: 19, abbr: language.lang('Preparation of accommodation and arrangements for arrival')},
      {state: 20, abbr: language.lang('Review the case and decide whether to take action again')},
    ], planNames: [
      {abbr: language.lang('ICT'), state: 'ICT'},
      {abbr: language.lang('PNP'), state: 'PNP'},
      {abbr: language.lang('Express Entry (T...)'), state: 'Express Entry (T...)'},
      {abbr: language.lang('Express Entry (CEC)'), state: 'Express Entry (CEC)'},
      {abbr: language.lang('Express Entry (FSW)'), state: 'Express Entry (FSW)'},
      {abbr: language.lang('Business visitor visa'), state: 'Business visitor visa'},
      {abbr: language.lang('Startup visa'), state: 'Startup visa'},
      {abbr: language.lang('Owner operator'), state: 'Owner operator'},
      {abbr: language.lang('Work permit'), state: 'Work permit'},
      {abbr: language.lang('Study permit'), state: 'Study permit'},
      {abbr: language.lang('Judicial review'), state: 'Judicial review'},
      {abbr: language.lang('PGWP'), state: 'PGWP'},
      {abbr: language.lang('Self employed'), state: 'Self employed'},
      {abbr: language.lang('Care giver program'), state: 'Care giver program'},
      {abbr: language.lang('PNP entrepreneurship'), state: 'PNP entrepreneurship'},
      {abbr: language.lang('Spousal sponsorship (PR)'), state: 'Spousal sponsorship (PR)'},
      {
        abbr: language.lang('Parents and grandparents sponsorship'),
        state: 'Parents and grandparents sponsorship'
      },
      {abbr: language.lang('Super Visa'), state: 'Super Visa'},
      {abbr: language.lang('Visitor visa (tourism)'), state: 'Visitor visa (tourism)'},
      {abbr: language.lang('Refugee'), state: 'Refugee'},
    ],
    isLawyer: oracle.isLawyer()
  }), methods: {
    search(item) {
      for (let i = 0; i < this.planNames.length; i++) {
        if (this.planNames[i].state == item) {
          return this.planNames[i].abbr
        }
      }
      return null
    }, openLawyer(item) {
      this.$router.push({name: 'lawyer', params: {id: item.lawyer.lawyer_index}})
    }, translate(state) {
      for (let i = 0; i < this.steps.length; i++) {
        if (this.steps[i].state == state) {
          return this.steps[i].abbr
        }
      }
      return ''
    }, openPlan(item) {
      this.plan = item.copy != null ? item.copy : item.plan
      this.showPlan = true
    }, openForm(item) {
      oracle.axios('lawyer/getConnectionForm', {parent_by: item.record_id}, (res) => {
        this.form = res.data
        this.showForm = true
      })
    }, saveItem(item, parent) {
      oracle.axios('plan/updateSubscription', item, (res) => {
        oracle.showMessage(res.message, null, null, 'checked');
        parent.expand = false
      })
    }, fetch() {
      oracle.axios('plan/getSubscriptions', {limit_by: 1000}, (res) => {
        for (let i = 0; i < res.data.length; i++) {
          if (res.data[i].data == null) res.data[i].data = {}
        }
        let array = {}
        let list = []
        for (let i = 0; i < res.data.length; i++) {
          let id
          let lawyer, user
          if (this.isLawyer) {
            user = res.data[i].user
            id = res.data[i].user.user_id
          } else {
            lawyer = res.data[i].lawyer
            id = res.data[i].lawyer.lawyer_id
          }
          let form = array[id]
          if (form == null) {
            form = {
              count: 1,
              record_id: res.data[i].record_id,
              hasForm: res.data[i].hasForm,
              array: [res.data[i]],
              user: user,
              lawyer: lawyer
            }
          } else {
            form.count++
            form.array.push(res.data[i])
          }
          array[id] = form
        }
        for (let key in array) {
          let form = array[key]
          form.expand = false
          list.push(form)
        }
        this.subscriptions = list
      })
    }, saveContact() {
      let data = {}
      data.current_installment = this.contract.current_installment
      data.commission_payed = this.contract.commission_payed
      data.installments = this.contract.installments
      data.total_payed = this.contract.total_payed
      data.commission = this.contract.commission
      data.record_id = this.contract.record_id
      data.total = this.contract.total
      oracle.axios('plan/updateSubscription', data, (res) => {
        this.contract = null
        this.showContract = false
        this.fetch()
        oracle.showMessage(language.lang("Contract has been updated successfully."), null, null, 'checked')
      })
    }, editItem(item) {
      this.contract = item
      this.showContract = true
    }, download(item) {
      oracle.newTab(item.file)
    }, openAttachments(item) {
      let array = []
      if (item.attachments != null) {
        for (let key in item.attachments) {
          let model = item.attachments[key]
          model.id = key
          array.push(model)
        }
      }
      this.attachments = array
      this.contract = item
      this.showAttachments = true
    }, saveAttachments() {
      let data = {}
      data.record_id = this.contract.record_id
      data.attachments = {}
      for (let i = 0; i < this.attachments.length; i++) {
        data.attachments[this.attachments[i].id] = this.attachments[i]
      }
      oracle.axios('plan/updateSubscription', data, (res) => {
        this.contract = null
        this.showAttachments = false
        this.fetch()
        oracle.showMessage(language.lang("Contract has been updated successfully."), null, null, 'checked')
      })
    }, addAttachment() {
      if (this.attachment != null && !oracle.isEmpty(this.title)) {
        this.uploading = true
        oracle.axiosUpload(this.attachment, (res) => {
          this.attachments.push({
            file: res.data,
            title: this.title,
            type: this.isLawyer ? 'consultant' : 'client',
            id: new Date().getTime()
          })
          this.attachment = null
          this.title = null
          this.uploading = false
        })
      } else {
        oracle.showMessage(language.lang('Attachment or title of the file is missing'))
      }
    }
  },
  mounted() {
    oracle.receive(oracle.UPDATE, () => {
      this.fetch()
    })
    if (this.lawyer != null) {
      oracle.axios('plan/getList', {parent_by: this.lawyer.lawyer_id, limit_by: 1000}, (res) => {
        this.plans = res.data
      })
    }
    this.fetch()
  }
};
</script>
<style>
</style>
